import { useEffect, useRef, useState } from 'react'

/**
 * Custom hook to force updates from partial form sections.
 */
export const useFormRef = () => {
  const [, setTick] = useState(0)
  const ref = useRef({ update: () => setTick(currentTick => currentTick + 1) })

  return ref
}

/**
 * Custom hook to handle partial form updates.
 */
export const useImperativeFormRef = (ref, callback, dependencies) => {
  useEffect(() => {
    ref.current = { ...ref.current, ...callback() }

    ref.current.update()
  }, dependencies)
}
